import { render, staticRenderFns } from "./Area.vue?vue&type=template&id=4f8ad484&scoped=true"
import script from "./Area.vue?vue&type=script&lang=js"
export * from "./Area.vue?vue&type=script&lang=js"
import style0 from "./Area.vue?vue&type=style&index=0&id=4f8ad484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ad484",
  null
  
)

export default component.exports